import { useQuery } from '@apollo/client';
import invariant from 'tiny-invariant';
import { ApolloProviderV4 } from '~/apollo/client-v4';
import { NotFound } from '~/components/common/NotFound';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { VomDetailPage } from '~/components/vom/VomDetailPage';
import { VIRTUAL_OUTCROP_DETAIL_TAB } from '~/routes/outcrop/$outcropId/virtual-outcrops/$vomId';
import { useGeologyWikiDetailOutletContext } from '~/routes/wiki/geology/$wikiId';

export default function GeologyWikiVirtualOutcropRoute() {
  return (
    <ApolloProviderV4>
      <PageInner />
    </ApolloProviderV4>
  );
}

function PageInner() {
  const { wikiPage } = useGeologyWikiDetailOutletContext();
  const vomId = wikiPage.vomExampleId;
  invariant(vomId, "This wiki page doesn't have a linked VOM.");

  const { data, loading } = useQuery(VIRTUAL_OUTCROP_DETAIL_TAB, {
    variables: { id: vomId },
  });

  const vom = data?.virtualOutcropModelGet;

  if (loading) return <SpinnerPlaceholder />;
  if (!vom) return <NotFound />;

  return <VomDetailPage vom={vom} />;
}
